import en from 'element-ui/lib/locale/lang/en.js'
import cn from 'element-ui/lib/locale/lang/zh-CN'
import tha from 'element-ui/lib/locale/lang/th.js'
import tw from 'element-ui/lib/locale/lang/zh-TW.js'
import esn from 'element-ui/lib/locale/lang/es.js'
import ptb from 'element-ui/lib/locale/lang/pt-br.js'
import jpn from 'element-ui/lib/locale/lang/ja.js'
import vie from 'element-ui/lib/locale/lang/vi.js'
import msa from 'element-ui/lib/locale/lang/ms.js'
import CNPKG from '@/i18n/langs/cn.js'

export const elementLangMap = {
  cn,
  en,
  tha,
  tw,
  esn,
  ptb,
  jpn,
  vie,
  msa
}

const langMap = {
  cn: () => import('@/i18n/langs/cn.js'),
  en: () => import('@/i18n/langs/en.js'),
  tw: () => import('@/i18n/langs/tw.js'),
  tha: () => import('@/i18n/langs/tha.js'),
  esn: () => import('@/i18n/langs/esn.js'),
  ptb: () => import('@/i18n/langs/ptb.js'),
  jpn: () => import('@/i18n/langs/jpn.js'),
  vie: () => import('@/i18n/langs/vie.js'),
  msa: () => import('@/i18n/langs/msa.js'),
}

export const appLangMap = {
  0: 'cn',
  1: 'en',
  2: 'tw',
  3: 'tha',
  4: 'esn',
  5: 'ptb',
  7: 'jpn',
  10: 'vie',
  16: 'msa'
}

export const countryLangMap = {
  CN: 'cn',
  TW: 'tw',
  GB: 'en',
  TH: 'tha',
  ES: 'esn',
  PT: 'ptb',
  JP: 'jpn',
  VN: 'vie',
  MY: 'msa'
}

let baseLangPkg = null

export async function initI18n () {
  const lang = localStorage.getItem('current_lang') || sessionStorage.getItem('url_lang') || localStorage.getItem('country_lang') || 'en'
  document.documentElement.setAttribute('lang', lang)
  const data = await langMap[lang]()
  baseLangPkg = data.default || {}
}

export function $vi18n (str, data) {
	str = str.replace(/(\$i18n#|#i18n\$)/g, '');
  str = str.trim();
  let values = Object.values(CNPKG)
  let keys = Object.keys(CNPKG)
  let index = values.indexOf(str)
  let key = keys[index]
  let res = baseLangPkg ? baseLangPkg[key] : CNPKG[key]
  res = strTemplate(res, data)
  return res || str;
}

function strTemplate (str, data) {
  if (!str) return ''
  str = str.replace(/\{(\w+)\}/g, ($1) => {
    let field = $1.replace(/\{|\}/g, '').trim()
    return data[field]
  })
  return str
}